import { Component, OnInit } from '@angular/core';
import { ChangePasswordComponent } from '../change-password.component';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-m-change-password',
  templateUrl: './m-change-password.component.html',
  styleUrls: ['./m-change-password.component.css']
})
export class MChangePasswordComponent extends ChangePasswordComponent implements OnInit {
  public key: any;
  ngOnInit(): void {
    if(this.key && this.key?.modal) {
      this.bsModalRef = this.injector.get<BsModalRef>(BsModalRef);
    }
    this.initFormData();
  }

}
